import toStringAccessor from './toStringAccessor';

export {
    toStringAccessor
};
